// extracted by mini-css-extract-plugin
module.exports = {"freeGiftsForProduct":"ProductFreeGifts_freeGiftsForProduct__6vfwU","separator":"ProductFreeGifts_separator__EnBEA"};